import axiosInstance from "api/setupAxios";

const ratesApi = {
  getRates: async (query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;

    const data = await axiosInstance.get(`/user/rates`, {
      params: {
        paginate: JSON.stringify({ pageSize, pageNumber }),
        sort: JSON.stringify([
          ["serviceRateType.service.title", "asc", "icase"],
        ]),
        filter: JSON.stringify(query.filter),
      },
    });

    return data?.data ?? data;
  },
};

export default ratesApi;
